import { SITE_CONFIG } from "../../app/config";
import { useHead } from "../../seo/useHead";
import { buildArticleSchema, buildBreadcrumbSchema } from "../../seo/structured-data";

type BlogLayoutProps = {
  title: string;
  subtitle?: string;
  description?: string;
  date: string;
  dateISO?: string;
  readTime: string;
  path: string;
  children: React.ReactNode;
};

export const BlogLayout = ({ title, subtitle, description, date, dateISO, readTime, path, children }: BlogLayoutProps): JSX.Element => {
  const metaDescription = description ?? subtitle ?? title;

  useHead({
    title,
    description: metaDescription,
    path,
    ogType: "article",
    jsonLd: [
      buildArticleSchema({
        title,
        description: metaDescription,
        path,
        datePublished: dateISO ?? "2024-09-01",
      }),
      buildBreadcrumbSchema([
        { name: "Home", url: "/" },
        { name: "Blog", url: "/blog" },
        { name: title, url: path },
      ]),
    ],
  });

  return (
  <div className="shell">
    <div className="blog-page">
      <header className="blog-header">
        <a href="/blog" className="blog-back">← All Articles</a>
        <div className="blog-meta">
          <span className="blog-date">{date}</span>
          <span className="blog-divider">·</span>
          <span className="blog-read-time">{readTime} read</span>
        </div>
        <h1 className="blog-title">{title}</h1>
        {subtitle && <p className="blog-subtitle">{subtitle}</p>}
      </header>
      <article className="blog-content">
        {children}
      </article>
      <footer className="blog-footer">
        <div className="blog-cta">
          <h3>Ready to Build Your Physical Music Collection?</h3>
          <p>Paste your Spotify playlist and discover where to buy your favorite albums on vinyl and CD.</p>
          <a href="/" className="blog-cta-button">Try {SITE_CONFIG.name} Free →</a>
        </div>
        <div className="blog-nav">
          <a href="/blog">← Back to Blog</a>
          <a href="/">Go to {SITE_CONFIG.name}</a>
        </div>
      </footer>
    </div>
  </div>
  );
};

